<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Qidaların kalori cədvəli</h1>

        <input type="text" v-model="query" placeholder="Qidanın adı">

        <div class="cart note" v-if="kcal">
          <p>Zülal: {{ protein.toFixed(2) }}</p>
          <p>Yağ: {{ fat.toFixed(2) }}</p>
          <p>Karbohidrat: {{ carbs.toFixed(2) }}</p>
          <p>Kalori: {{ kcal.toFixed(2) }}</p>
        </div>

        <table>
          <thead>
            <tr>
              <th @click="sort('name')">Qidanın adı (100 qr) <span>&harr;</span></th>
              <th @click="sort('protein')">Zülal <span>&harr;</span></th>
              <th @click="sort('fat')">Yağ <span>&harr;</span></th>
              <th @click="sort('carbs')">Karbohidrat <span>&harr;</span></th>
              <th @click="sort('kcal')">Kkal <span>&harr;</span></th>
              <th>Əlavə et</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(product, i) in filteredProducts">
              <td>{{ product.name }}</td>
              <td>{{ product.protein }}</td>
              <td>{{ product.fat }}</td>
              <td>{{ product.carbs }}</td>
              <td>{{ product.kcal }}</td>
              <td><button class="add" @click="addToCart(i)">+</button></td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>
</template>

<script> 
  export default {
    data(){
      return {
        query: '',
        sortDir: 'desc',
        kcal: 0,
        protein: 0,
        fat: 0,
        carbs: 0,
        cart: [],
        products: [
          { "name": "Qarabaşaq sıyığı", "protein": "4.5", "fat": "1.6", "carbs": "27.4", "kcal": "137" },
          { "name": "Qarğıdalı lopası", "protein": "6.5", "fat": "2.9", "carbs": "83.8", "kcal": "372" },
          { "name": "Manna sıyığı", "protein": "2.5", "fat": "0.3", "carbs": "16.4", "kcal": "77" },
          { "name": "Yulaf sıyığı", "protein": "3.2", "fat": "1.8", "carbs": "15.4", "kcal": "93" },
          { "name": "Yulaf lopası", "protein": "11.9", "fat": "7.5", "carbs": "69.1", "kcal": "358" },
          { "name": "Perlova sıyığı", "protein": "3.2", "fat": "0.5", "carbs": "22.7", "kcal": "102" },
          { "name": "Darı sıyığı", "protein": "3", "fat": "0.8", "carbs": "17.2", "kcal": "92" },
          { "name": "Düyü sıyığı", "protein": "1.5", "fat": "0.2", "carbs": "17.3", "kcal": "79" },
          { "name": "Qoyun əti", "protein": "16.2", "fat": "15.3", "carbs": "0", "kcal": "201" },
          { "name": "Mal əti", "protein": "18.7", "fat": "12.6", "carbs": "0", "kcal": "191" },
          { "name": "Dovşan əti", "protein": "20.6", "fat": "12.8", "carbs": "0", "kcal": "197" },
          { "name": "Dana əti", "protein": "19.9", "fat": "1.1", "carbs": "0", "kcal": "91" },
          { "name": "Qaz əti", "protein": "16.4", "fat": "33.1", "carbs": "0", "kcal": "359" },
          { "name": "Hinduşka əti", "protein": "21.1", "fat": "12.3", "carbs": "0.6", "kcal": "192" },
          { "name": "Toyuq əti", "protein": "20.4", "fat": "8.6", "carbs": "0.8", "kcal": "161" },
          { "name": "Ördək əti", "protein": "16.4", "fat": "61.3", "carbs": "0", "kcal": "348" },
          { "name": "Yoqurt 1.5%", "protein": "4.3", "fat": "1.5", "carbs": "8.4", "kcal": "65" },
          { "name": "Yoqurt 3.2%", "protein": "5", "fat": "3.2", "carbs": "8.9", "kcal": "87" },
          { "name": "Süd 0%", "protein": "2.8", "fat": "0", "carbs": "4.6", "kcal": "34" },
          { "name": "Süd 1%", "protein": "2.8", "fat": "1", "carbs": "4.6", "kcal": "43" },
          { "name": "Süd 2.5%", "protein": "2.8", "fat": "2.5", "carbs": "4.6", "kcal": "53" },
          { "name": "Süd 3.2%", "protein": "2.8", "fat": "3.2", "carbs": "4.6", "kcal": "58" },
          { "name": "Qatılaşdırılmış süd", "protein": "7.3", "fat": "7.7", "carbs": "9.7", "kcal": "139" },
          { "name": "Xama 10%", "protein": "3", "fat": "10", "carbs": "2.9", "kcal": "118" },
          { "name": "Xama 15%", "protein": "3", "fat": "15", "carbs": "2.9", "kcal": "163" },
          { "name": "Xama 20%", "protein": "3", "fat": "20", "carbs": "2.9", "kcal": "208" },
          { "name": "Holland pendiri", "protein": "26.4", "fat": "26.5", "carbs": "0", "kcal": "352" },
          { "name": "Kəsmik yağlı", "protein": "14", "fat": "18", "carbs": "1.9", "kcal": "236" },
          { "name": "Kəsmik yağsız", "protein": "18.2", "fat": "0.6", "carbs": "1.8", "kcal": "89" },
          { "name": "Badımcan", "protein": "1", "fat": "0.2", "carbs": "6", "kcal": "25" },
          { "name": "Yunan qabağı", "protein": "0.6", "fat": "0.3", "carbs": "5.7", "kcal": "27" },
          { "name": "Kələm", "protein": "1.8", "fat": "0", "carbs": "5.4", "kcal": "28" },
          { "name": "Gül kələm", "protein": "2.5", "fat": "0", "carbs": "4.9", "kcal": "29" },
          { "name": "Kartof", "protein": "2", "fat": "0.1", "carbs": "19.7", "kcal": "83" },
          { "name": "Soğan", "protein": "1.7", "fat": "0", "carbs": "9.5", "kcal": "43" },
          { "name": "Kök", "protein": "1.3", "fat": "0.1", "carbs": "6.9", "kcal": "32" },
          { "name": "Xiyar", "protein": "0.8", "fat": "0.1", "carbs": "2.8", "kcal": "15" },
          { "name": "Yaşıl bibər", "protein": "1.3", "fat": "0", "carbs": "6.9", "kcal": "33" },
          { "name": "Çuğundur", "protein": "1.5", "fat": "0.1", "carbs": "8.8", "kcal": "43" },
          { "name": "Pomidor", "protein": "1.1", "fat": "0.2", "carbs": "3.7", "kcal": "20" },
          { "name": "Lobya", "protein": "21", "fat": "1.6", "carbs": "52.7", "kcal": "310" },
          { "name": "Mərci", "protein": "21.6", "fat": "1.1", "carbs": "48", "kcal": "314" },
          { "name": "Qarabaşaq", "protein": "12.6", "fat": "3.3", "carbs": "62.1", "kcal": "313" },
          { "name": "Bulgur", "protein": "12.3", "fat": "1.3", "carbs": "57.6", "kcal": "342" },
          { "name": "Düyü", "protein": "6.7", "fat": "0.7", "carbs": "78.9", "kcal": "344" },
          { "name": "Ananas", "protein": "0.4", "fat": "0", "carbs": "11.8", "kcal": "48" },
          { "name": "Portağal", "protein": "0.9", "fat": "0", "carbs": "8.4", "kcal": "38" },
          { "name": "Qarpız", "protein": "1", "fat": "0", "carbs": "8", "kcal": "38" },
          { "name": "Banan", "protein": "1.5", "fat": "0", "carbs": "22.4", "kcal": "90" },
          { "name": "Üzüm", "protein": "0.4", "fat": "0", "carbs": "17.5", "kcal": "69" },
          { "name": "Kişmiş", "protein": "2.3", "fat": "0", "carbs": "71.2", "kcal": "279" },
          { "name": "Nar", "protein": "0.9", "fat": "0", "carbs": "11.8", "kcal": "52" },
          { "name": "Armud", "protein": "0.4", "fat": "0", "carbs": "10.7", "kcal": "42" },
          { "name": "Əncir", "protein": "0.7", "fat": "0", "carbs": "13.9", "kcal": "56" },
          { "name": "Kivi", "protein": "1", "fat": "0", "carbs": "11", "kcal": "61" },
          { "name": "Qaysı qurusu", "protein": "5.2", "fat": "0", "carbs": "65.9", "kcal": "272" },
          { "name": "Mandarin", "protein": "0.8", "fat": "0", "carbs": "8.6", "kcal": "38" },
          { "name": "Xurma qurusu (finik)", "protein": "2.5", "fat": "0", "carbs": "72.1", "kcal": "281" },
          { "name": "Alma", "protein": "0.4", "fat": "0", "carbs": "11.3", "kcal": "46" },
          { "name": "Çörək", "protein": "9.22", "fat": "1.0", "carbs": "49.2", "kcal": "265" },
          { "name": "Makaron", "protein": "10.4", "fat": "1.1", "carbs": "69.7", "kcal": "337" },
          { "name": "Peçenye", "protein": "7.5", "fat": "11.8", "carbs": "74.9", "kcal": "417" },
          { "name": "Şokolad", "protein": "5.4", "fat": "35.3", "carbs": "56.5", "kcal": "544" },
          { "name": "Kozinak", "protein": "14.8", "fat": "42.6", "carbs": "34.5", "kcal": "576" },
          { "name": "Noxud (bişmiş)", "protein": "6.0", "fat": "0", "carbs": "9.0", "kcal": "60" },
          { "name": "Göbələk (şampinyon)", "protein": "4.3", "fat": "1.0", "carbs": "0.1", "kcal": "27" },
          { "name": "Avokado", "protein": "2.0", "fat": "20.0", "carbs": "6.0", "kcal": "212" },
          { "name": "Qoz", "protein": "15.2", "fat": "65.2", "carbs": "17", "kcal": "654" },
          { "name": "Fındıq ", "protein": "15", "fat": "61", "carbs": "16.1", "kcal": "628" },
          { "name": "Badam ", "protein": "18.6", "fat": "57.7", "carbs": "16.2", "kcal": "645" },
          { "name": "Yumurta ", "protein": "13", "fat": "11", "carbs": "1.1", "kcal": "155" }
        ]
      }
    },
    methods: {
      addToCart: function(i){
        this.cart.push(this.filteredProducts[i].name);
        this.kcal += +this.filteredProducts[i].kcal;
        this.protein += +this.filteredProducts[i].protein;
        this.fat += +this.filteredProducts[i].fat;
        this.carbs += +this.filteredProducts[i].carbs;
      },
      sort: function(s) {

        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';

        if(s == 'name'){
          switch (this.sortDir) {
            case 'asc' :
              this.products.sort(function(a, b){ return a.name.localeCompare(b.name, 'az'); }); break;
            case 'desc' :
              this.products.sort(function(a, b){ return -a.name.localeCompare(b.name, 'az'); }); break;
            }
        } else {
          switch (this.sortDir) {
            case 'asc' : 
              this.products.sort(function(a, b){ return b[s] - a[s]; }); break;
            case 'desc' : 
              this.products.sort(function(a, b){ return a[s] - b[s]; }); break;
          }
        }
      }
    }, 
    computed: {
      filteredProducts: function() {
        let query = this.query;
        return this.products.filter(function(dir) {
          return ( dir.name.toLowerCase().indexOf(query.toLowerCase()) !== -1 );
        });
      }
    },
    created: function () {
      this.sort('name');
    }
  }
</script>

<style scoped>
  table tr th {
    cursor: pointer;
    white-space: nowrap;
  }
  table tr th span {
    display: inline-block;
    font-size: 0.8rem;
    color: #f0f0f0;
    margin: 0 5px;
    transform: rotate(90deg);
  }

  table tr th:first-child,
  table tr td:first-child {
    text-align: left;
  }

  button.add {
    background: #FFF;
    border: 2px solid #f0f0f0;
    font-size: 2rem;
    line-height: 2rem;
    padding: 0.5rem 2rem;
    color: #036;
  }
  .cart {
    position: sticky;
    top: 0;
    color: #036;
    font-weight: bold;
    padding: 0;
    display: flex;
    justify-content: space-around;
  }
  .cart p {
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/calc/Calories.vue